import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { CalendarModule } from "primeng/calendar";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { AccordionModule } from "primeng/accordion";
import { DataViewModule } from "primeng/dataview";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { TabViewModule } from "primeng/tabview";
import { AppSharedModule } from "../../shared/app-shared.module";
import { PersonSelectorModule } from "../personselector/personselector.module";

import { ReportInboxMainComponent } from "./components/report-inbox-main.component";
import { ReportInboxComponent } from "./report-inbox/report-inbox.component";
import { ScheduledReportsComponent } from "./scheduled-reports/scheduled-reports.component";
import { RiJobTableComponent } from "./scheduled-reports/ri-job-table/ri-job-table.component";
import { RiJobScheduleTableComponent } from "./scheduled-reports/ri-job-schedule-table/ri-job-schedule-table.component";
import { RiJobRecipientsTableComponent } from "./scheduled-reports/ri-job-recipients-table/ri-job-recipients-table.component";
import { DataService_ScheduledJobs } from "./scheduled-reports/shared/data.service";

import { RiJobAddComponent } from "./scheduled-reports/ri-job-table/ri-job-add/ri-job-add.component";
import { RiJobAddUsersComponent } from "./scheduled-reports/ri-job-table/ri-job-add/ri-job-add-users/ri-job-add-users.component";
import { RiJobEditComponent } from "./scheduled-reports/ri-job-table/ri-job-edit/ri-job-edit.component";
import { RiScheduleModifyComponent } from "./scheduled-reports/ri-job-schedule-table/ri-schedule-modify/ri-schedule-modify.component";
import { RiAddRecipientsComponent } from "./scheduled-reports/ri-job-recipients-table/ri-add-recipients/ri-add-recipients.component";
import { DataService_Inbox } from "./report-inbox/shared/data.service";
import { ReportInboxDetailComponent } from "./report-inbox-detail/report-inbox-detail.component";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@NgModule({
	declarations: [
		ReportInboxMainComponent,
		ReportInboxComponent,
		ScheduledReportsComponent,
		RiJobTableComponent,
		RiJobScheduleTableComponent,
		RiJobRecipientsTableComponent,
		RiJobAddComponent,
		RiJobAddUsersComponent,
		RiJobEditComponent,
		RiScheduleModifyComponent,
		RiAddRecipientsComponent,
		ReportInboxDetailComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		CalendarModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		AccordionModule,
		SchoolselectorModule,
		DataViewModule,
		TabViewModule,
		ProgressSpinnerModule,
	],
	providers: [ConfirmationService, DataService_ScheduledJobs, DataService_Inbox],
})
export class ReportInboxModule {}
